import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, Router } from "vue-router"

import { isNavigationFailure } from "vue-router"

import $logger from "@/utils/logger"

export function createRouterGuards(router: Router) {
  router.beforeEach(async (to, from, next) => {
    if (from.name || from.fullPath !== "/") {
      $logger.log("页面路由跳转", {
        to: to.fullPath,
        from: from.fullPath,
      })
    }

    next()
  })

  router.afterEach((to, from, failure) => {
    if (isNavigationFailure(failure)) {
      console.error("failed navigation", failure)
    }
  })

  router.onError(
    (error: unknown, to: RouteLocationNormalized, from: RouteLocationNormalizedLoaded) => {
      console.log(error, to, from)
    },
  )
}
